module.exports = __webpack_public_path__ + "static/media/aboutImage.7a98d267.jpg";